import { moment } from '@hotjar/webapp/lib/moment';

const ONE_DAY_MS = 1000 * 60 * 60 * 24;

/**
 * Check if given timestamp happened less than 7 days from now.
 */
export function isLessThan7DaysSince(timestamp: number): boolean {
  const difference = moment().diff(moment(timestamp));
  const daysDiff = difference / ONE_DAY_MS;

  return daysDiff < 7;
}
